import React, {useState, useEffect} from 'react';

import * as S from './BookingDetails.styles';
import {convertFromEpochToDate} from '../../../../../utils/utils';

const BookingDetails = ({tabData, completedData, upcomingData, incentivesData}) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [detailsData, setDetailsData] = useState(completedData);

  const handleTab = (idx, data) => {
    setTabIndex(idx);
    if (idx === 0) {
      setDetailsData(completedData);
    } else if (idx === 1) {
      setDetailsData(upcomingData);
    } else {
      setDetailsData(incentivesData);
    }
  };

  useEffect(() => {
    setDetailsData(completedData);
  }, [completedData]);

  return (
    <S.BkngDtl>
      {tabData && tabData.length > 0 && (
        <S.BkngDtlTab>
          {tabData.map(({id, label, data}, index) => (
            <S.BkngDtlTabItem
              isActive={tabIndex === index}
              key={index}
              onClick={() => handleTab(index, data)}
            >
              {label}
            </S.BkngDtlTabItem>
          ))}
        </S.BkngDtlTab>
      )}
      <S.BkngDtlBody>
        {tabIndex !== 2 &&
          detailsData &&
          detailsData.length > 0 &&
          detailsData.map(
            ({id, from, to, bookingId, bookingDate, travelStartDate, actualAmount}) => (
              <S.BkngDtlRow key={bookingId}>
                <S.BkngDtlCol>
                  <S.BkngDtlHdng>
                    {from} {from && <span className="sprite ic_onwayArrow"></span>} {to}
                  </S.BkngDtlHdng>
                  <S.BkngDtlBkngid>
                    Booking ID: <span>{bookingId}</span>
                  </S.BkngDtlBkngid>
                </S.BkngDtlCol>
                <S.BkngDtlCol>
                  <S.BkngDtlBkngid>Booked: {convertFromEpochToDate(bookingDate)}</S.BkngDtlBkngid>
                  <S.BkngDtlBkngid>
                    Travel: {convertFromEpochToDate(travelStartDate)}
                  </S.BkngDtlBkngid>
                </S.BkngDtlCol>
                <S.BkngDtlCol>
                  <S.BkngDtlPrice>{actualAmount.toFixed(2)}</S.BkngDtlPrice>
                </S.BkngDtlCol>
              </S.BkngDtlRow>
            ),
          )}
        {tabIndex === 2 &&
          detailsData &&
          detailsData.length > 0 &&
          detailsData.map(({creditDate, message, walletEarn}, index) => (
            <S.BkngDtlRow key={index}>
              <S.BkngDtlCol>
                {/*<S.BkngDtlHdng>{from} <span className='sprite ic_onwayArrow'></span> {to}</S.BkngDtlHdng>*/}
                <S.BkngDtlBkngid>
                  <span>{message}</span>
                </S.BkngDtlBkngid>
              </S.BkngDtlCol>
              <S.BkngDtlCol>
                <S.BkngDtlBkngid>Credited On: {creditDate}</S.BkngDtlBkngid>
                {/*<S.BkngDtlBkngid>Travel: {travelStartDate}</S.BkngDtlBkngid>*/}
              </S.BkngDtlCol>
              <S.BkngDtlCol>
                <S.BkngDtlPrice>{walletEarn}</S.BkngDtlPrice>
              </S.BkngDtlCol>
            </S.BkngDtlRow>
          ))}
      </S.BkngDtlBody>
    </S.BkngDtl>
  );
};

export default BookingDetails;
